import type { ReactElement, Ref } from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "../../lib/utils";
import { tabRailTabVariants } from "./styles";
import type { TabRailVariant } from "./useTabRailContext";

interface TabRailLinkTabProps {
  value: string;
  index: number;
  selected: boolean;
  ref?: Ref<HTMLElement>;
  variant: TabRailVariant;
  onSelectTab?: (id: string) => void;
  className?: string;
  children: ReactElement;
}

// Slot concatenates `className` rather than tailwind-merging it, so the router Link's own classes
// land after these unmerged; a consumer styling a link tab should use `TabRail.Tab`'s `className`.
export const TabRailLinkTab = ({
  value,
  index,
  selected,
  ref,
  variant,
  onSelectTab,
  className,
  children,
}: TabRailLinkTabProps) => (
  <Slot
    ref={ref}
    data-slot="tab-rail-tab"
    data-tab-id={value}
    data-state={selected ? "active" : "inactive"}
    aria-current={selected ? "page" : undefined}
    onClick={() => onSelectTab?.(value)}
    style={{ gridColumn: index + 1, gridRow: 1 }}
    className={cn(tabRailTabVariants({ variant, selected }), className)}
  >
    {children}
  </Slot>
);
